"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpOk = exports.traceClient = exports.makeHttpClient = exports.jsonClient = exports.HttpContentType = exports.parseHeaderParams = exports.makeFetchClient = exports.foldHeaderValue = exports.foldHeaders = exports.makeUrl = void 0;
const HttpValueCollection_1 = require("./HttpValueCollection");
function makeUrl({ authority, fragment, params, path, query, scheme }, base) {
    let url = '';
    if (scheme && authority) {
        url += scheme + ':';
    }
    if (authority) {
        url += '//' + authority;
    }
    if (path) {
        url += replace(normalisePath(!!authority, path), params);
    }
    if (query) {
        if (typeof query !== 'string') {
            query = new URLSearchParams(query).toString();
        }
        url += '?' + query;
    }
    if (fragment) {
        if (typeof fragment !== 'string') {
            fragment = new URLSearchParams(fragment).toString();
        }
        url += '#' + fragment;
    }
    if (base) {
        return new URL(url, base).toString();
    }
    return url;
}
exports.makeUrl = makeUrl;
function normalisePath(absolute, ...path) {
    const parts = path
        .reduce((a, x) => a.concat(x), [])
        .join('/')
        .split('/');
    const result = [];
    for (const part of parts) {
        if (part && part !== '.') {
            if (part === '..') {
                if (result.length && result[result.length - 1] !== '..') {
                    result.pop();
                }
                else if (!absolute) {
                    result.push('..');
                }
            }
            else {
                result.push(part);
            }
        }
    }
    const norm = result.join('/');
    return absolute ? '/' + norm : norm;
}
function replace(base, replacements) {
    if (!replacements) {
        return base;
    }
    return Object.keys(replacements).reduce((a, x) => a.replace(new RegExp(`${x}(?=\\/|$)`, 'g'), replacements[x]), base);
}
function foldHeaders(headers) {
    return Object.keys(headers).reduce((a, x) => {
        const value = foldHeaderValue(headers[x]);
        return value ? { ...a, [x]: value } : a;
    }, {});
}
exports.foldHeaders = foldHeaders;
function foldHeaderValue(value) {
    if (Array.isArray(value)) {
        if (value.length === 0) {
            return;
        }
        return value.join(', ');
    }
    return value;
}
exports.foldHeaderValue = foldHeaderValue;
function makeFetchClient(fetchImpl) {
    return async (req) => {
        const { body, headers = {}, method = body ? 'POST' : 'GET', url } = req;
        if (typeof body !== 'undefined' &&
            typeof body !== 'string' &&
            body !== null) {
            throw new Error(`expected body to be string, undefined or null`);
        }
        const response = await fetchImpl(url, {
            method,
            headers: foldHeaders(headers),
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            body: body,
        });
        const responseBody = await response.text();
        let responseHeaders = {};
        response.headers.forEach((value, name) => {
            responseHeaders = (0, HttpValueCollection_1.addValue)(responseHeaders, name, value);
        });
        const ret = {
            status: response.status,
            headers: responseHeaders,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            body: responseBody,
        };
        return ret;
    };
}
exports.makeFetchClient = makeFetchClient;
function parseHeaderParams(str) {
    if (!str) {
        return [undefined, {}];
    }
    const [value, ...params] = str.split(';');
    return [
        value.trim(),
        params.reduce((a, x) => {
            const sepIndex = x.indexOf('=');
            if (sepIndex < 0) {
                // skip invalid input
                return a;
            }
            const k = x.substring(0, sepIndex).trim();
            const v = x.substring(sepIndex + 1, x.length).trim();
            return { ...a, [k]: v };
        }, {}),
    ];
}
exports.parseHeaderParams = parseHeaderParams;
var HttpContentType;
(function (HttpContentType) {
    HttpContentType["Form"] = "application/x-www-form-urlencoded";
    HttpContentType["Json"] = "application/json";
})(HttpContentType = exports.HttpContentType || (exports.HttpContentType = {}));
function jsonClient() {
    return (client) => {
        return async (req) => {
            const body = req.body;
            let headers = req.headers || {};
            let encodedBody;
            if (typeof body === 'undefined' || typeof body === 'string') {
                encodedBody = body || undefined;
            }
            else {
                const [contentType] = parseHeaderParams((0, HttpValueCollection_1.getLastValue)(headers, 'content-type') || HttpContentType.Json);
                switch (contentType) {
                    case HttpContentType.Json:
                        encodedBody = JSON.stringify(body);
                        break;
                    case HttpContentType.Form:
                        encodedBody = new URLSearchParams(body).toString();
                        break;
                    default:
                        throw new Error(`don't know how to encode content-type: ${contentType}`);
                }
                headers = (0, HttpValueCollection_1.setValue)(headers, 'content-type', contentType);
            }
            const response = await client({ ...req, body: encodedBody, headers });
            let responseBody = response.body;
            const [responseType] = parseHeaderParams((0, HttpValueCollection_1.getLastValue)(response.headers, 'content-type'));
            if (responseBody && responseType === HttpContentType.Json) {
                if (typeof responseBody === 'string') {
                    try {
                        responseBody = JSON.parse(responseBody.toString());
                    }
                    catch { }
                }
            }
            return {
                ...response,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                body: responseBody,
            };
        };
    };
}
exports.jsonClient = jsonClient;
function makeHttpClient(client, middleware) {
    return middleware.reduce((c, m) => m(c), client);
}
exports.makeHttpClient = makeHttpClient;
function traceClient(trace) {
    return (client) => {
        if (!trace) {
            return client;
        }
        return async (request) => {
            trace({ msg: `client request`, request });
            try {
                const response = (await client(request));
                trace({ msg: `client response`, response });
                return response;
            }
            catch (err) {
                trace({ msg: `client unhandled error`, err });
                throw err;
            }
        };
    };
}
exports.traceClient = traceClient;
function httpOk(status) {
    return status >= 200 && status < 300;
}
exports.httpOk = httpOk;
//# sourceMappingURL=HttpClient.js.map